export default __webpack_public_path__ + "static/media/aksons-banner.49bfa35b.png";